import upperFirst from 'lodash/upperFirst';
import React from 'react';
import { Row, TableBodyPropGetter, TableBodyProps } from 'react-table';

import { CellStatus, CellsWithMergesRows } from '../types';
import { StyledTableBody, StyledTableCell, StyledTableRow } from './styled';

export type Props<T extends object> = {
  rows: Row<T>[];
  prepareRow: (row: Row<T>) => void;
  getTableBodyProps: (propGetter?: TableBodyPropGetter<T>) => TableBodyProps;
  tableCellDataId: string;
  className?: string;
};

const Body = <T extends CellsWithMergesRows>({
  rows,
  prepareRow,
  getTableBodyProps,
  tableCellDataId,
  className,
}: Props<T>): JSX.Element => {
  return (
    <StyledTableBody {...getTableBodyProps()} className={className}>
      {rows.map((row, index) => {
        prepareRow(row);

        return (
          <StyledTableRow {...row.getRowProps()} $selected={row.isSelected} key={index}>
            {row.cells.map((cell, i) => {
              const cellWithMergedRows = cell.row.original.cellMerges?.find(
                (cellMerge) => cellMerge.cellId === cell.column.id
              );

              if (cellWithMergedRows && cellWithMergedRows.status === CellStatus.merged) return null;

              return (
                <StyledTableCell
                  $left={cell.column.stickyLeft}
                  rowSpan={cellWithMergedRows?.mergedCellsCount ? cellWithMergedRows.mergedCellsCount : undefined}
                  {...cell.getCellProps()}
                  data-testid={`${tableCellDataId}${upperFirst(cell.column.id)}`}
                  className={`${cell.column.tableBorders?.columns?.left ? 'leftBorder' : ''} ${
                    cell.column.tableBorders?.columns?.right ? 'rightBorder' : ''
                  } ${cell.column.sticky ? 'sticky' : ''}`}
                >
                  {cell.render('Cell')}
                </StyledTableCell>
              );
            })}
          </StyledTableRow>
        );
      })}
    </StyledTableBody>
  );
};

export default Body;
